import * as React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import cn from 'classnames';

import { useCabinetStore, useProjectStore, useRouterStore } from 'stores';
import { urls } from 'shared/entities/domain';
import { IconSize } from 'shared/entities/components/Icon';

import { LogoIcon, LogoFullIcon } from '../icons';

import './Logo.modules.scss';

const LOGO_HEIGHT = 28;

type Props = {
  className?: string;
  height?: number;
  width?: number;
  full?: boolean;
  iconSize?: IconSize;
};

const Logo: React.FC<Props> = ({
  className,
  height = LOGO_HEIGHT,
  full = true,
  iconSize = IconSize.LM
}) => {
  const projectStore = useProjectStore();
  const cabinetStore = useCabinetStore();
  const routerStore = useRouterStore();

  const link = React.useMemo(() => {
    if (!cabinetStore.entity) {
      return '';
    }

    if (cabinetStore.entity.needToShowSubscriptionPage) {
      return urls.SUBSCRIPTION.root;
    }

    return projectStore.projectId
      ? urls.PROJECT.tabs.ONBOARDING.create({
          projectId: projectStore.projectId
        })
      : '';
  }, [projectStore.projectId, cabinetStore.entity]);

  const disabled = !link || routerStore.matchPath(link);

  return (
    <Link
      to={link}
      styleName="logo"
      className={cn(className, disabled && 'disabled')}
    >
      {full ? (
        <LogoFullIcon height={height} />
      ) : (
        <LogoIcon iconSize={iconSize} />
      )}
    </Link>
  );
};

export default observer(Logo);
